import * as React from "react";
import { Translate } from "react-localize-redux";
import { Link } from "react-router-dom";
import "./Stepper.scss";

interface IProps {
  current: 1 | 2 | 3; // The current step
  finishedEnabled?: boolean;
  isContactRequest?: boolean;
  summaryEnabled?: boolean;
}
class Stepper extends React.Component<IProps, {}> {
  public render() {
    return (
      <div className="stepper d-flex flex-wrap">
        <Link className={"btn col-auto text-center step " + (this.props.current === 1 ? "active" : "")} to="/">
          <Translate id="SOP" />
        </Link>
        <span className="chevron" />
        {(this.props.isContactRequest) && (
          <Link className={"btn col-auto text-center step"} tabIndex={!this.props.summaryEnabled ? -1 : 0} to="/contactRequest">
            <Translate id="Contacts" />
          </Link>
        )}
        {(!this.props.isContactRequest) && (
          <Link className={"btn col-auto text-center step " + (this.props.current === 2 ? "active" : "") + (!this.props.summaryEnabled ? " disabled" : "")} tabIndex={!this.props.summaryEnabled ? -1 : 0} to="/summary">
            <Translate id="Contacts" />
          </Link>
        )}
        <span className="chevron" />
        <Link className={"btn col-auto text-center step " + (this.props.current === 3 ? "active" : "") + (!this.props.finishedEnabled ? " disabled" : "")} tabIndex={!this.props.finishedEnabled ? -1 : 0} to="/finished">
          <Translate id="Finished" />
        </Link>
      </div>
    );
  }
}

export default Stepper;
